<div class="header-row flex flex-row xs:!hidden">
  <div class="flex flex-row justify-start items-center flex-[100%] max-w-[15%]">
    {{ '+INSTALLATIONS.INSTALLATION.HYDRAULIC_SCHEMATIC.TABLE.SVG_HEADER' | translate }}
  </div>
  <div class="flex flex-row justify-start items-center flex-[100%] max-w-[35%]">
    {{ '+INSTALLATIONS.INSTALLATION.HYDRAULIC_SCHEMATIC.TABLE.VDD_DESCRIPTION_HEADER' | translate }}
  </div>
  <div class="flex flex-row justify-start items-center flex-[100%] max-w-[50%]">
    {{ '+INSTALLATIONS.INSTALLATION.HYDRAULIC_SCHEMATIC.TABLE.VDD_VALUE_HEADER' | translate }}
  </div>
</div>
<ng-container *ngFor="let svgVdd of svgVdds">
  <app-hydraulic-schematic-vdd-table-item [vdd]="svgVdd"></app-hydraulic-schematic-vdd-table-item>
</ng-container>
